import { useEffect, useState } from "react";
import { DexxNumericInput, DexxIntegerInput } from "../utils/Input";
import GenericPopup from "./GenericPopup";
import { euroFormat, quantityFormat } from "../../utils";
import { useDispatch } from "react-redux";
import { actionCreators } from "../../state";
import { bindActionCreators } from "redux";
import Popup from "../Popup";
import PopupRowData from "./utils/PopupRowData";
import PopupLabelAndValue from "./utils/PopupLabelAndValue";
import PopupDivider from "./utils/PopupDivider";

export default function P2PCreateOfferPopup(props: {
    tokenInfo: any, isShown: boolean,
    closeFunction: Function, refreshList: Function
}): JSX.Element {

    const [quantity, setQuantity] = useState<number>(0)
    const [price, setPrice] = useState<number>(0.00)
    const [balance, setBalance] = useState<any>()
    const [maxTokenA, setMaxTokenA] = useState<number>(0)
    const [response, setResponse] = useState<any[]>([])
    const dispatch = useDispatch()
    const actions = bindActionCreators(actionCreators, dispatch)

    //RESPONSE POPUP
    const [showPopUp, setShowPopUp] = useState<boolean>(false)
    const [titlePopUp, setTitlePopUp] = useState<string>("")
    const [msgPopUp, setMsgPopUp] = useState<string>("")

    function handleSubmit() {
        let r = {
            token_uuid: props.tokenInfo.uuid,
            quantity: quantity,
            per_token_price: parseFloat(price.toString().replace(",", ".")),
        }
        if (quantity <= 0) {
            setShowPopUp(true)
            setTitlePopUp("Sorry!")
            setMsgPopUp("Please specify the quantity of " + props.tokenInfo.ticker + " to create the offer.")
        } else if (quantity - 0 > maxTokenA - 0) {
            setShowPopUp(true)
            setTitlePopUp("Sorry!")
            setMsgPopUp("You do not own enough " + props.tokenInfo.ticker + " tokens to create this offer.")
        } else if (price <= 0) {
            setShowPopUp(true)
            setTitlePopUp("Sorry!")
            setMsgPopUp("Please specify a valid price.")
        } else {
            actions.createP2pAskOffer(r, setResponse)
        }
    }

    useEffect(() => {
        if (props.isShown === true)
            actions.getBalance(setBalance)
    }, [props.isShown])

    useEffect(() => {
        if (balance) {
            let securityEntries = balance?.balance?.security_entries
            let tokensByCat = securityEntries ? securityEntries.map((t: any) => t.class_balance) : []
            let Alltokens = [].concat.apply([], tokensByCat)
            let tokens: any[] = Alltokens.filter((t: any) => t.symbol === props.tokenInfo.ticker)
            let newMax = tokens.length > 0 ? tokens[0].available_quantity : 0
            setMaxTokenA(newMax)
        }

    }, [balance])

    useEffect(() => {
        if (response.length > 0) {
            switch (response[0]) {
                case 200:
                case 204:
                    setShowPopUp(true)
                    setTitlePopUp("Success")
                    setMsgPopUp("Your offer has been created.")
                    props.refreshList(true)
                    props.closeFunction()
                    break
                case 0:
                    break
                default:
                    setShowPopUp(true)
                    setTitlePopUp("Sorry!")
                    setMsgPopUp("We encountered an error creating your offer.")
                    break
            }
        }
    }, [response])

    let balancePT: string = balance?.payment_tokens?.available_total

    return <>
        <Popup show={showPopUp} title={titlePopUp} msg={msgPopUp} btnOk={true}
            close={() => { setShowPopUp(false) }} />
        <GenericPopup
            handleSubmit={handleSubmit}
            closeFunction={props.closeFunction}
        >
            <PopupRowData backgroundColor="succ8_lightest">
                <PopupLabelAndValue label="My Balance" value="" />
                <PopupLabelAndValue label={props.tokenInfo.ticker + ":"}
                    value={quantityFormat(maxTokenA)} />
                <PopupLabelAndValue label={"XEUR:"}
                    value={euroFormat(balancePT ? balancePT : 0)} />
            </PopupRowData>
            <PopupDivider color="succ8" />
            <PopupRowData>
                <PopupLabelAndValue label={"Token name:"}
                    value={props.tokenInfo.asset_name} />
                <PopupLabelAndValue label={"Ticker:"}
                    value={props.tokenInfo.ticker} />
            </PopupRowData>
            <PopupDivider color="succ8" />
            <PopupRowData backgroundColor="succ8_lighter" nColumns="2" className="gap-4 pb-4">
                <div className="text-sm font-normal col-span-2">Create an offer to sell</div>
                <PopupLabelAndValue label={"Quantity *"}
                    value={
                        <DexxIntegerInput value={quantity} fun={setQuantity}
                            className={""} max={maxTokenA} />
                    } />
                <PopupLabelAndValue label={"Price per Token *"}
                    value={
                        <DexxNumericInput value={price} className="" fun={setPrice} />
                    } />
            </PopupRowData>
            <PopupDivider color="succ8" className="mb-8 md:mb-12"/>
        </GenericPopup>
    </>
}
